import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { LoadingState, StateMessage } from '@/components/StateMessage/StateMessage';
import { useProjectContext } from '@/project/ProjectContext';
import styles from './ProjectGate.module.css';

type Props = {
  children: ReactNode;
  /** Pagina’s die een geselecteerd project vereisen (mailbox, inbox, campagnes). */
  requireSelection?: boolean;
  /** Titel op empty states (optioneel). */
  pageTitle?: string;
};

export function ProjectGate({ children, requireSelection = false, pageTitle }: Props) {
  const { projects, projectsLoading, selectedProjectId } = useProjectContext();

  if (projectsLoading) return <LoadingState />;

  if (projects.length === 0) {
    return (
      <StateMessage title={pageTitle ?? 'Geen project'}>
        Maak eerst een werkruimte aan om leads, mail en campagnes te beheren.
        <div className={styles.actions}>
          <Link to="/app/projects" className={styles.link}>
            Project aanmaken
          </Link>
        </div>
      </StateMessage>
    );
  }

  if (requireSelection && !selectedProjectId) {
    return (
      <StateMessage title={pageTitle ?? 'Kies een project'}>
        Selecteer een project in de switcher linksboven, of open projectinstellingen.
        <div className={styles.actions}>
          <Link to="/app/projects" className={styles.link}>
            Projecten beheren
          </Link>
        </div>
      </StateMessage>
    );
  }

  return <>{children}</>;
}

export function ProjectSelectionHint({ message }: { message?: string }) {
  const { selectedProjectId } = useProjectContext();
  if (selectedProjectId) return null;

  return (
    <div className={styles.hint}>
      <StateMessage title="Alle projecten">
        {message ??
          'Geen project geselecteerd — je ziet leads uit alle projecten. Kies een project in de switcher om te filteren.'}
      </StateMessage>
    </div>
  );
}
